/* Kaufzone: Ein-Klick-Weg auf zwei Pflanzen. Stand 20.09.2026.
   Setzt die vorhandene Mengeneingabe auf 2 und loest deren Ereignisse aus,
   damit das Theme-Skript den Wert uebernimmt. Kein eigener Warenkorb-Aufruf. */
(function () {
  'use strict';

  function setQty(root, n) {
    var input = root.querySelector('[data-qty-input]');
    if (!input) return false;
    input.value = String(n);
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  }

  document.addEventListener('click', function (ev) {
    var btn = ev.target && ev.target.closest && ev.target.closest('[data-pack-two]');
    if (!btn) return;
    ev.preventDefault();

    var section = btn.closest('[data-product-section]') || document;
    if (!setQty(section, 2)) return;

    /* Rueckmeldung am Knopf selbst, damit auf dem Handy sichtbar ist,
       dass etwas passiert ist. Kein Dialog, keine Umleitung. */
    var pack = btn.closest('[data-pack]');
    if (pack) pack.classList.add('is-set');
    btn.textContent = 'Menge steht auf 2';
    btn.disabled = true;

    /* Den Kaufknopf in den Blick holen, aber nur wenn er ausserhalb liegt. */
    var add = section.querySelector('.fl-buy__cart .fl-buy__add');
    if (add) {
      var r = add.getBoundingClientRect();
      if (r.top < 0 || r.bottom > window.innerHeight) {
        add.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }
    }
  }, false);

  /* Wird die Menge anderweitig veraendert, Knopf wieder freigeben. */
  document.addEventListener('input', function (ev) {
    var t = ev.target;
    if (!t || !t.matches || !t.matches('[data-qty-input]')) return;
    var section = t.closest('[data-product-section]');
    if (!section) return;
    var pack = section.querySelector('[data-pack]');
    var btn = section.querySelector('[data-pack-two]');
    if (!pack || !btn) return;
    if (parseInt(t.value, 10) !== 2) {
      pack.classList.remove('is-set');
      btn.disabled = false;
      btn.textContent = 'Zwei nehmen';
    }
  }, false);
})();